export class ResetPasswordData {
  emailAddress = '';
}
